export default {
  DOCUMENT_INVOICE: 1,
  DOCUMENT_CREDIT: 2,
  DOCUMENT_CANCELLATION: 3
};
